var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoRef",attrs:{"autoplay":_vm.autoplay,"width":"620","controls":"","type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }